import { signOut } from 'firebase/auth';
import { auth } from '../firebase';

export const SignOut: () => void = () => {
    signOut(auth)
        .then((res) => {})
        .catch((err) => {
            throw err;
        });
};
